import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiAlertCircle, FiCheckCircle } = FiIcons;

function AdminSources({ sources }) {
  return (
    <section className="admin-panel">
      <div className="admin-panel-head">
        <div>
          <span className="admin-overline">SYNDICATION</span>
          <h2>RSS sources</h2>
          <p>Feed status, import totals and the latest reported errors.</p>
        </div>
      </div>

      <div className="admin-table-wrap">
        <table>
          <thead>
            <tr>
              <th>Publication</th>
              <th>Desk</th>
              <th>Region</th>
              <th>Status</th>
              <th>Last success</th>
              <th>Imported</th>
            </tr>
          </thead>
          <tbody>
            {sources.map((source) => (
              <tr key={source.id}>
                <td>
                  <b>{source.name}</b>
                  <small>{source.feed_url}</small>
                  {source.last_error && (
                    <small className="source-error">
                      {source.last_error}
                    </small>
                  )}
                </td>
                <td>{source.category}</td>
                <td>{source.country}</td>
                <td>
                  <span
                    className={
                      source.active && !source.last_error
                        ? 'status-live'
                        : 'status-paused'
                    }
                  >
                    <SafeIcon
                      icon={
                        source.active && !source.last_error
                          ? FiCheckCircle
                          : FiAlertCircle
                      }
                    />
                    {source.active
                      ? source.last_error ? 'Error' : 'Active'
                      : 'Paused'}
                  </span>
                </td>
                <td>{source.updated}</td>
                <td>{source.imported}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {!sources.length && (
        <p className="admin-empty">
          No RSS source records were returned by Supabase.
        </p>
      )}
    </section>
  );
}

export default AdminSources;